import { useState, useCallback } from "react"
import MurmurHash3 from "murmurhash3js"
import { Buffer } from "buffer"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHeart as faHeartFilled, faCheck, faX, faCircle } from "@fortawesome/free-solid-svg-icons"
import { faHeart } from "@fortawesome/free-regular-svg-icons"
import gearHead from "./assets/json/parameters/GearInfoHead.json"
import gearClothes from "./assets/json/parameters/GearInfoClothes.json"
import gearShoes from "./assets/json/parameters/GearInfoShoes.json"
import weaponInfoMain from "./assets/json/parameters/WeaponInfoMain.json"
import weaponInfoSpecial from "./assets/json/parameters/WeaponInfoSpecial.json"
import { defaultGearList, defaultImportData, defaultProfile } from "./DefaultEntries"
import BynameAdjective from "./assets/json/parameters/BynameAdjectiveInfo.json"
import BynameSubject from "./assets/json/parameters/BynameSubjectInfo.json"
import NamePlateBg from "./assets/json/parameters/NamePlateBgInfo.json"
import catalogue1 from "./assets/json/parameters/catalogue/Ctl_Season01_1.spl__CatalogBookParam.json"
import catalogue2 from "./assets/json/parameters/catalogue/Ctl_Season02_1.spl__CatalogBookParam.json"
import catalogue3 from "./assets/json/parameters/catalogue/Ctl_Season03_1.spl__CatalogBookParam.json"
import catalogue4 from "./assets/json/parameters/catalogue/Ctl_Season04_1.spl__CatalogBookParam.json"
import catalogue5 from "./assets/json/parameters/catalogue/Ctl_Season05_1.spl__CatalogBookParam.json"
import catalogue6 from "./assets/json/parameters/catalogue/Ctl_Season06_1.spl__CatalogBookParam.json"
import catalogue7 from "./assets/json/parameters/catalogue/Ctl_Season07_1.spl__CatalogBookParam.json"
import catalogue8 from "./assets/json/parameters/catalogue/Ctl_Season08_1.spl__CatalogBookParam.json"
import figureInfo from "./assets/json/parameters/LockerGoodsFigureInfo.json"
import stickerInfo from "./assets/json/parameters/LockerGoodsStickerInfo.json"
import doorInfo from "./assets/json/parameters/LockerGoodsMainPartInfo.json"
import EmoteInfo from "./assets/json/parameters/EmoteInfo.json"

export const SEASON_TIMES = [
    1661990400000, 1669852800000, 1677628800000, 1685577600000, 1693526400000, 1701388800000, 1709251200000, 1717200000000, 1725148800000,
    1733011200000, 1740787200000, 1748736000000, 1756684800000, 1764547200000, 1772323200000, 1780272000000, 1788220800000, 1796083200000,
    1803859200000, 1811808000000, 1819756800000, 1827619200000, 1835481600000, 1843430400000, 1851379200000, 1859241600000, 1867017600000,
    1874966400000, 1882915200000, 1890777600000, 1898553600000, 1906502400000, 1914451200000, 1922313600000, 1930089600000, 1938038400000,
    1945987200000, 1953849600000, 1961712000000, 1969660800000, 1977609600000, 1985472000000, 1993248000000, 2001196800000, 2009145600000,
    2017008000000, 2024784000000, 2032732800000, 2040681600000, 2048544000000, 2056320000000, 2064268800000, 2072217600000, 2080080000000,
    2087942400000, 2095891200000, 2103840000000, 2111702400000, 2119478400000, 2127427200000, 2135376000000, 2143238400000, 2151014400000,
    2158963200000, 2166912000000, 2174774400000, 2182550400000, 2190499200000, 2198448000000, 2206310400000, 2214172800000, 2222121600000,
    2230070400000, 2237932800000, 2245708800000, 2253657600000, 2261606400000, 2269468800000, 2277244800000, 2285193600000, 2293142400000,
    2301004800000, 2308780800000, 2316729600000, 2324678400000, 2332540800000, 2340403200000, 2348352000000, 2356300800000, 2364163200000,
    2371939200000, 2379888000000, 2387836800000, 2395699200000, 2403475200000, 2411424000000, 2419372800000, 2427235200000, 2435011200000,
    2442960000000, 2450908800000, 2458771200000, 2466633600000, 2474582400000, 2482531200000, 2490393600000, 2498169600000, 2506118400000,
    2514067200000, 2521929600000,
]

const get_current_season = () => {
    let i = 0
    const x = Date.now()
    for (let k of SEASON_TIMES) {
        if (k >= x) break
        i += 1
    }
    return i
}

export const CURRENT_SEASON = get_current_season()

export const get_catalogue = num => {
    switch (num) {
        case 1:
            return catalogue1
        case 2:
            return catalogue2
        case 3:
            return catalogue3
        case 4:
            return catalogue4
        case 5:
            return catalogue5
        case 6:
            return catalogue6
        case 7:
            return catalogue7
        case 8:
            return catalogue8
        default:
            return [catalogue8, catalogue5, catalogue6, catalogue7][num % 4]
    }
}

export const ability_order = [
    "MainInk_Save",
    "SubInk_Save",
    "InkRecovery_Up",
    "HumanMove_Up",
    "SquidMove_Up",
    "SpecialIncrease_Up",
    "RespawnSpecialGauge_Save",
    "SpecialSpec_Up",
    "RespawnTime_Save",
    "JumpTime_Save",
    "SubSpec_Up",
    "OpInkEffect_Reduction",
    "SubEffect_Reduction",
    "Action_Up",
]

export const brand_names = [
    "B00",
    "B01",
    "B02",
    "B03",
    "B04",
    "B05",
    "B06",
    "B07",
    "B08",
    "B09",
    "B10",
    "B11",
    "B15",
    "B16",
    "B17",
    "B18",
    "B19",
    "B20",
    "B97",
    "B98",
    "B99",
]

export const MappingDrinkBrand = {
    MainInk_Save: "MainInk_Save",
    SubInk_Save: "SubInk_Save",
    InkRecovery_Up: "InkRecovery_Up",
    HumanMove_Up: "HumanMove_Up",
    SquidMove_Up: "SquidMove_Up",
    SpecialIncrease_Up: "SpecialIncrease_Up",
    RespawnSpecialGauge_Save: "RespawnSpecialGauge_Save",
    SpecialTime_Up: "SpecialSpec_Up",
    RespawnTime_Save: "RespawnTime_Save",
    JumpTime_Save: "JumpTime_Save",
    BombDistance_Up: "SubSpec_Up",
    OpInkEffect_Reduction: "OpInkEffect_Reduction",
    SubEffect_Reduction: "SubEffect_Reduction",
    Action_Up: "Action_Up",
    Unknown: "Unknown",
}

export const MapingBrandDrink = {
    MainInk_Save: "MainInk_Save",
    SubInk_Save: "SubInk_Save",
    InkRecovery_Up: "InkRecovery_Up",
    HumanMove_Up: "HumanMove_Up",
    SquidMove_Up: "SquidMove_Up",
    SpecialIncrease_Up: "SpecialIncrease_Up",
    RespawnSpecialGauge_Save: "RespawnSpecialGauge_Save",
    SpecialSpec_Up: "SpecialTime_Up",
    RespawnTime_Save: "RespawnTime_Save",
    JumpTime_Save: "JumpTime_Save",
    SubSpec_Up: "BombDistance_Up",
    OpInkEffect_Reduction: "OpInkEffect_Reduction",
    SubEffect_Reduction: "SubEffect_Reduction",
    Action_Up: "Action_Up",
    Unknown: "Unknown",
}

export const SkillIDs = {
    MainInk_Save: 0,
    SubInk_Save: 1,
    InkRecovery_Up: 2,
    HumanMove_Up: 3,
    SquidMove_Up: 4,
    SpecialIncrease_Up: 5,
    RespawnSpecialGauge_Save: 6,
    SpecialSpec_Up: 7,
    RespawnTime_Save: 8,
    JumpTime_Save: 9,
    SubSpec_Up: 10,
    OpInkEffect_Reduction: 11,
    SubEffect_Reduction: 12,
    Action_Up: 13,
    StartAllUp: 100,
    EndAllUp: 101,
    MinorityUp: 102,
    ComeBack: 103,
    SquidMoveSpatter_Reduction: 104,
    DeathMarking: 105,
    ThermalInk: 106,
    Exorcist: 107,
    ExSkillDouble: 108,
    SuperJumpSign_Hide: 109,
    ObjectEffect_Up: 110,
    SomersaultLanding: 111,
    Unknown: 255,
}

export const SkillIDsRev = {
    0: "MainInk_Save",
    1: "SubInk_Save",
    2: "InkRecovery_Up",
    3: "HumanMove_Up",
    4: "SquidMove_Up",
    5: "SpecialIncrease_Up",
    6: "RespawnSpecialGauge_Save",
    7: "SpecialSpec_Up",
    8: "RespawnTime_Save",
    9: "JumpTime_Save",
    10: "SubSpec_Up",
    11: "OpInkEffect_Reduction",
    12: "SubEffect_Reduction",
    13: "Action_Up",
    100: "StartAllUp",
    101: "EndAllUp",
    102: "MinorityUp",
    103: "ComeBack",
    104: "SquidMoveSpatter_Reduction",
    105: "DeathMarking",
    106: "ThermalInk",
    107: "Exorcist",
    108: "ExSkillDouble",
    109: "SuperJumpSign_Hide",
    110: "ObjectEffect_Up",
    111: "SomersaultLanding",
    255: "Unknown",
}

export const ability_list_drinks_rev = val => {
    return MapingBrandDrink[SkillIDsRev[val]]
}

function get_weapon_dict() {
    return Object.fromEntries(weaponInfoMain.map(entry => [entry.Id, entry]))
}

export const weapon_dict = get_weapon_dict()

function get_special_dict() {
    return Object.fromEntries(weaponInfoSpecial.map(entry => [entry.Id, entry]))
}

export const profile_is_initalized = profile => {
    return (profile.BynameAdjectiveMap[3000] ?? false) && (profile.BynameSubjectMap[3000] ?? false)
}

export const missing_season_items = (type, profile) => {
    if (CURRENT_SEASON < 9) {
        const title_id = 2499 + CURRENT_SEASON
        const banner_id = 10000 + CURRENT_SEASON
        switch (type) {
            case "NamePlateBg":
                if (profile.NamePlateBgMap[banner_id]) {
                    return []
                } else {
                    return [banner_id]
                }
            case "Byname":
                if (profile.BynameAdjectiveMap[title_id]) {
                    return []
                } else {
                    return [title_id]
                }
            default:
                return []
        }
    } else {
        const half_season = ((CURRENT_SEASON - 1) % 4) + 1
        const res = []
        switch (type) {
            case "NamePlateBg":
                if (!profile.NamePlateBgMap[10000 + 4 + half_season]) {
                    res.push(10000 + 4 + half_season)
                }
                if (!profile.NamePlateBgMap[10000 + half_season]) {
                    res.push(10000 + half_season)
                }
                break
            case "Byname":
                if (!profile.BynameAdjectiveMap[2499 + 4 + half_season]) {
                    res.push(2499 + 4 + half_season)
                }
                if (!profile.BynameAdjectiveMap[2499 + half_season]) {
                    res.push(2499 + half_season)
                }
                break
            default:
                return []
        }
        return res
    }
}

export const special_dict = get_special_dict()

export const bynameAdjectives = BynameAdjective.map(entry => entry.Id)
export const bynameSubjects = BynameSubject.map(entry => entry.Id)
export const nameplates = NamePlateBg

export const bynameAdjectivesSpecial = BynameAdjective.filter(
    e => !(e.HowToGet === "Shop" && e.Season <= CURRENT_SEASON) && !(e.HowToGet === "Catalog" && e.Season <= CURRENT_SEASON - 2)
).map(entry => entry.Id)
export const bynameSubjectsSpecial = BynameSubject.filter(
    e => !(e.HowToGet === "Shop" && e.Season <= CURRENT_SEASON) && !(e.HowToGet === "Catalog" && e.Season <= CURRENT_SEASON - 2)
).map(entry => entry.Id)

export const bynameAdjectivesShop = () => {
    return BynameAdjective.filter(
        e => (e.HowToGet === "Shop" && e.Season <= CURRENT_SEASON) || (e.HowToGet === "Catalog" && e.Season <= CURRENT_SEASON - 2)
    ).map(entry => entry.Id)
}

export const bynameSubjectsShop = () => {
    return BynameSubject.filter(
        e => (e.HowToGet === "Shop" && e.Season <= CURRENT_SEASON) || (e.HowToGet === "Catalog" && e.Season <= CURRENT_SEASON - 2)
    ).map(entry => entry.Id)
}

export const bynameAdjectivesShopNoCatalog = () => {
    return BynameAdjective.filter(e => e.HowToGet === "Shop").map(entry => entry.Id)
}

export const bynameSubjectsShopNoCatalog = () => {
    return BynameSubject.filter(e => e.HowToGet === "Shop").map(entry => entry.Id)
}

export const nameplatesShop = () => {
    return nameplates.filter(
        e => (e.HowToGet === "Shop" && e.Season <= CURRENT_SEASON) || (e.HowToGet === "Catalog" && e.Season <= CURRENT_SEASON - 2)
    )
}

export const nameplatesShopNoCatalog = () => {
    return nameplates.filter(e => e.HowToGet === "Shop")
}

export const getElemFromProp = elem => {
    if (elem.SubType) {
        switch (elem.Type) {
            case "NamePlateBg":
                return nameplates.filter(e => e.Id === elem.ElemId)[0]
            case "Byname":
                return [elem.ElemId, elem.ElemId]
            default:
                return null
        }
    }
    switch (elem.Type) {
        case "NamePlateBg":
            const n = elem.NamePlateBgInfo.replace("Work/Gyml/NamePlateBgInfo/", "").replace(".spl__NamePlateBgInfo.gyml", "")
            return nameplates.filter(e => e.__RowId === n)[0]
        case "Byname":
            const a = elem.Byname_Adjective.replace("Work/Gyml/Byname/", "").replace(".spl__BynameAdjectiveInfo.gyml", "")
            const s = elem.Byname_Subject.replace("Work/Gyml/Byname/", "").replace(".spl__BynameSubjectInfo.gyml", "")
            return [a, s]
        case "GearPack":
            // HeadInfo
            // ClothesInfo
            // ShoesInfo
            const ghi = elem.HeadInfo.replace("Work/Gyml/", "").replace(".spl__GearInfo.gyml", "")
            const chi = elem.ClothesInfo.replace("Work/Gyml/", "").replace(".spl__GearInfo.gyml", "")
            const shi = elem.ShoesInfo.replace("Work/Gyml/", "").replace(".spl__GearInfo.gyml", "")
            return [
                gearHead.filter(e => e.__RowId === ghi)[0],
                gearClothes.filter(e => e.__RowId === chi)[0],
                gearShoes.filter(e => e.__RowId === shi)[0],
            ]
        case "Gear_Head":
            const gh = elem.GearInfo.replace("Work/Gyml/", "").replace(".spl__GearInfo.gyml", "")
            return gearHead.filter(e => e.__RowId === gh)[0]
        case "Gear_Clothes":
            const ch = elem.GearInfo.replace("Work/Gyml/", "").replace(".spl__GearInfo.gyml", "")
            return gearClothes.filter(e => e.__RowId === ch)[0]
        case "Gear_Shoes":
            const sh = elem.GearInfo.replace("Work/Gyml/", "").replace(".spl__GearInfo.gyml", "")
            return gearShoes.filter(e => e.__RowId === sh)[0]
        case "Emote":
            const em = elem.EmoteInfo.replace("Work/Gyml/", "").replace(".spl__EmoteInfo.gyml", "")
            return EmoteInfo.filter(e => e.__RowId === em)[0]
        case "LockerSticker":
            const ls = elem.LockerGoodsStickerInfo.replace("Work/Gyml/", "").replace(".spl__LockerGoodsStickerInfo.gyml", "")
            return stickerInfo.filter(e => e.__RowId === ls)[0]
        case "LockerFigure":
            const lf = elem.LockerGoodsFigureInfo.replace("Work/Gyml/", "").replace(".spl__LockerGoodsFigureInfo.gyml", "")
            return figureInfo.filter(e => e.__RowId === lf)[0]
        default:
            return null
    }
}

const get_eligible_items = (type, collection, replacer) => {
    let profile
    let gear_db
    try {
        profile = JSON.parse(localStorage.getItem("profile")) ?? defaultProfile
        gear_db = JSON.parse(localStorage.getItem("gearList")) ?? defaultGearList
    } catch (e) {
        profile = defaultProfile
        gear_db = defaultGearList
    }
    const eligible_items = []

    for (let catalogue = 1; catalogue <= CURRENT_SEASON; catalogue++) {
        const current_catalogue = get_catalogue(catalogue)
        for (let elem of current_catalogue.ItemArray) {
            let owns = false
            if (elem.Type !== type) continue
            const item = getElemFromProp(elem)
            switch (type) {
                case "Gear_Head":
                    owns = item.Id in gear_db.HaveGearHeadMap
                    break
                case "Gear_Clothes":
                    owns = item.Id in gear_db.HaveGearClothesMap
                    break
                case "Gear_Shoes":
                    owns = item.Id in gear_db.HaveGearShoesMap
                    break
                case "LockerSticker":
                    owns = item.Id in profile.GoodsMap
                    break
                case "LockerFigure":
                    owns = item.Id in profile.GoodsMap
                    break
                case "LockerMainPart":
                    owns = item.Id in profile.GoodsMap
                    break
                default:
                    owns = false
                    break
            }
            if (owns) {
                eligible_items.push(replacer(elem))
            }
        }
    }
    const res = []
    for (const elem of collection) {
        if (elem.Season <= CURRENT_SEASON && (elem.HowToGet === "Shop" || eligible_items.includes(elem.__RowId))) {
            res.push(elem)
        }
    }

    return res
}

export const get_eligible_headgear = () =>
    get_eligible_items("Gear_Head", gearHead, elem => elem.GearInfo.replace("Work/Gyml/", "").replace(".spl__GearInfo.gyml", ""))
export const get_eligible_clothes = () =>
    get_eligible_items("Gear_Clothes", gearClothes, elem => elem.GearInfo.replace("Work/Gyml/", "").replace(".spl__GearInfo.gyml", ""))
export const get_eligible_shoes = () =>
    get_eligible_items("Gear_Shoes", gearShoes, elem => elem.GearInfo.replace("Work/Gyml/", "").replace(".spl__GearInfo.gyml", ""))

export const figureShop = () =>
    get_eligible_items("LockerFigure", figureInfo, elem =>
        elem.LockerGoodsFigureInfo.replace("Work/Gyml/", "").replace(".spl__LockerGoodsFigureInfo.gyml", "")
    )
export const stickerShop = () =>
    get_eligible_items("LockerSticker", stickerInfo, elem =>
        elem.LockerGoodsStickerInfo.replace("Work/Gyml/", "").replace(".spl__LockerGoodsStickerInfo.gyml", "")
    )

export const doorShop = () =>
    get_eligible_items("LockerMainPart", doorInfo, elem =>
        elem.LockerMainPartInfo.replace("Work/Gyml/", "").replace(".spl__LockerMainPartInfo.gyml", "")
    )

const coopEnemyList = [
    "SakelienStandard",
    "SakelienLarge",
    "SakelienSmall",
    "SakeFlyBagman",
    "SakelienBomber",
    "SakelienCupTwins",
    "SakelienShield",
    "SakelienSnake",
    "SakelienTower",
    "Sakediver",
    "Sakerocket",
    "SakePillar",
    "SakeDolphin",
    "SakeArtillery",
    "SakeSaucer",
    "SakelienGolden",
    "SakelienGeyser",
    "Sakedozer",
    "SakeCarrier",
    "SakeCopter",
    "SakeBigMouth",
    "SakeBigMouthGold",
    "SakeShip",
    "SakelienGiant",
    "SakeRope",
    "SakeJaw",
    "SakeBigBalloon",
    "SakeGhost",
    "SakeBalloon",
    "SakeWheel",
    "Dummy0",
    "Random",
]

export const coopRareEnemy_dict = Object.fromEntries(coopEnemyList.map((coopEnemyList, idx) => [coopEnemyList, idx]))

export const useLocalStorage = (storageKey, fallbackState) => {
    let jsondata = ""
    try {
        jsondata = JSON.parse(localStorage.getItem(storageKey)) ?? fallbackState
    } catch (e) {
        jsondata = fallbackState
        alert("Gear Database Damaged. Please contact @LeanyYoshi about this. Your Database has been reseted.")
    }
    const [value, _setValue] = useState(jsondata)

    window.addEventListener("storage", () => {
        jsondata = JSON.parse(localStorage.getItem(storageKey)) ?? fallbackState
        setValue(jsondata)
    })

    const setValue = useCallback(
        value => {
            _setValue(value)
            localStorage.setItem(storageKey, JSON.stringify(value))
        },
        [storageKey]
    )

    return [value, setValue]
}

export const get_full_data_struct = () => {
    const gearList = JSON.parse(localStorage.getItem("gearList")) ?? defaultGearList
    const userdata = JSON.parse(localStorage.getItem("importData")) ?? defaultImportData
    const profile = JSON.parse(localStorage.getItem("profile")) ?? defaultProfile

    return {
        GearDB: {
            HaveGearHeadMap: gearList.HaveGearHeadMap,
            HaveGearShoesMap: gearList.HaveGearShoesMap,
            HaveGearClothesMap: gearList.HaveGearClothesMap,
        },
        UserData: { CloudRandomSet: userdata.CloudRandomSet, UserKey: userdata.UserKey, H: userdata.H },
        Profile: {
            BadgeList: profile.BadgeList,
            GoodsMap: profile.GoodsMap,
            BynameAdjectiveMap: profile.BynameAdjectiveMap,
            BynameSubjectMap: profile.BynameSubjectMap,
            NamePlateBgMap: profile.NamePlateBgMap,
            SkillChipMap: profile.SkillChipMap,
            Versus: profile.Versus,
            Coop: profile.Coop,
            Level: profile.Level,
            EmoteMap: profile.EmoteMap,
        },
        LastUpdated: Date.now(),
    }
}

export const getSkillId = name => {
    if (name === "Unknown") return 255
    return SkillIDs[name]
}

export const getSkillName = id => {
    if (id === 255) return "Unknown"
    for (const [k, v] of Object.entries(SkillIDs)) {
        if (v === id) return k
    }
}

export const getName = (t, v, gear) => t("translation:" + v + "." + gear.__RowId.substring(4))

export const skillImage = name => `https://leanny.github.io/splat3/images/skill/${name}.png`
export const brandImage = name => `https://leanny.github.io/splat3/images/brand/${name}.png`
export const gearImage = name => `https://leanny.github.io/splat3/images/gear/${name}.png`
export const emoteImage = name => `https://leanny.github.io/splat3/images/emote/${name}.png`
export const lockerImage = name => `https://leanny.github.io/splat3/images/zakka/${name}.png`

export function useBoolState(initial = false) {
    const [bool, setBool] = useState(initial)
    const onTrue = useCallback(() => setBool(true), [setBool])
    const onFalse = useCallback(() => setBool(false), [setBool])
    return [bool, onTrue, onFalse]
}

export function fromBase64(str) {
    return new TextDecoder().decode(Buffer.from(str, "base64"))
}

export function decrypt_key(tmp_key, hash) {
    const key = hash & 0xff
    const decrypted = new TextDecoder().decode(Buffer.from(tmp_key, "base64").map(e => e ^ key))
    if (hash >>> 0 !== MurmurHash3.x86.hash32(decrypted) >>> 0) {
        return undefined
    }
    return decrypted
}

export function valid_key() {
    const data = JSON.parse(localStorage.getItem("importData")) ?? {}
    const hash = data.H ?? 0
    return hash > 0 && decrypted_key() !== undefined
}

export function decrypted_key() {
    const data = JSON.parse(localStorage.getItem("importData")) ?? {}
    const tmp_key = data.UserKey ?? ""
    const hash = data.H ?? 0
    return decrypt_key(tmp_key, hash)
}

export function encrypt_key(key) {
    const hash = MurmurHash3.x86.hash32(key) >>> 0
    const k = hash & 0xff
    const encrypted = Buffer.from(key, "utf8").map(e => e ^ k)
    return [encrypted.toString("base64"), hash]
}

export function hasContext() {
    const data = JSON.parse(localStorage.getItem("importData")) ?? {}
    return seed_is_initalised(data, "Lot")
}

export const dict_length = d => Object.keys(d).length

export const get_drink_order = () => {
    return ability_order.map(e => MapingBrandDrink[e])
}

export const drink_order = get_drink_order()

export const generate_abilities = t => {
    const res = [{ value: "None", label: t("misc:Common.None") }]
    for (const ability of ability_order) {
        res.push({ value: ability, label: t("translation:CommonMsg.Gear.GearPowerName." + ability) })
    }
    res.sort((a, b) => {
        if (a.value === "None") return false
        if (b.value === "None") return true
        return a.label > b.label
    })
    return res
}

export const generate_drinks = t => {
    const res = [{ value: "None", label: t("misc:Common.None") }]
    for (const ability of ability_order) {
        res.push({ value: ability, label: t("translation:CommonMsg.Lobby.LobbyFoodName." + MapingBrandDrink[ability]) })
    }
    res.sort((a, b) => {
        if (a.value === "None") return false
        if (b.value === "None") return true
        return a.label > b.label
    })
    return res
}

export const generate_brands = (t, no_default) => {
    const res = []
    if (no_default === undefined) {
        res.push({ value: "None", label: t("misc:Common.None") })
    }
    for (const brand of brand_names) {
        res.push({ value: brand, label: t("translation:CommonMsg.Gear.GearBrandName." + brand) })
    }
    res.sort((a, b) => {
        if (a.value === "None") return false
        if (b.value === "None") return true
        return a.label > b.label
    })
    return res
}

export const get_reward_types = t => [
    {
        value: "LimitedNamePlateBg",
        label: t("translation:CommonMsg.Glossary.NamePlateBg") + " (" + t("other:Seasonal.Season") + ")",
        original: {
            Grade: 0,
            NotSameNum: 1,
            Percent: 0.1,
            SameNum: 1,
            SubType: "Limited",
            SubstituteArrayId: 2,
            Type: "NamePlateBg",
        },
    },
    {
        value: "LimitedByname",
        label: t("translation:CommonMsg.Glossary.Byname") + " (" + t("other:Seasonal.Season") + ")",
        original: {
            Grade: 1,
            NotSameNum: 1,
            Percent: 0.3,
            SameNum: 1,
            SubType: "Limited",
            SubstituteArrayId: 2,
            Type: "Byname",
        },
    },
    {
        value: "AllGearSkillChip",
        label: t("translation:LayoutMsg.Cmn_Menu_00.T_Count_01") + " x 10",
        original: {
            Grade: 2,
            NotSameNum: 1,
            Percent: 0.6,
            SameNum: 10,
            SubType: "None",
            SubstituteArrayId: -1,
            Type: "AllGearSkillChip",
        },
    },
    {
        value: "NamePlateBg",
        label: t("translation:CommonMsg.Glossary.NamePlateBg"),
        original: {
            Grade: 3,
            NotSameNum: 1,
            Percent: 6.0,
            SameNum: 1,
            SubType: "None",
            SubstituteArrayId: -1,
            Type: "NamePlateBg",
        },
    },
    {
        value: "Emote",
        label: t("translation:CommonMsg.Glossary.Emote"),
        original: {
            Grade: 3,
            NotSameNum: 1,
            Percent: 2,
            SameNum: 10,
            SubType: "None",
            SubstituteArrayId: -1,
            Type: "Emote",
        },
    },
    {
        value: "MiniGameCardPack",
        label: t("translation:CommonMsg.Glossary.CardPack"),
        original: {
            Grade: 3,
            NotSameNum: 1,
            Percent: 4.0,
            SameNum: 1,
            SubType: "None",
            SubstituteArrayId: -1,
            Type: "MiniGameCardPack",
        },
    },
    {
        value: "FoodParty",
        label: t("other:Extra.FoodTicket") + " (" + t("other:Extra.Party") + ")",
        original: {
            Grade: 3,
            NotSameNum: 1,
            Percent: 3.0,
            SameNum: 1,
            SubType: "FoodParty",
            SubstituteArrayId: -1,
            Type: "FoodTicket",
        },
    },
    {
        value: "Byname",
        label: t("translation:CommonMsg.Glossary.Byname"),
        original: {
            Grade: 4,
            NotSameNum: 1,
            Percent: 22.0,
            SameNum: 1,
            SubType: "None",
            SubstituteArrayId: -1,
            Type: "Byname",
        },
    },
    {
        value: "GearSkillChip",
        label: t("translation:LayoutMsg.Cmn_Menu_00.T_Count_01"),
        original: {
            Grade: 4,
            NotSameNum: 1,
            Percent: 10.0,
            SameNum: 3,
            SubType: "None",
            SubstituteArrayId: -1,
            Type: "GearSkillChip",
        },
    },
    {
        value: "Food100",
        label: t("other:Extra.FoodTicket") + " (100%)",
        original: {
            Grade: 4,
            NotSameNum: 1,
            Percent: 7.0,
            SameNum: 1,
            SubType: "Food100",
            SubstituteArrayId: -1,
            Type: "FoodTicket",
        },
    },
    {
        value: "LockerSticker",
        label: t("translation:CommonMsg.Glossary.Sticker"),
        original: {
            Grade: 5,
            NotSameNum: 2,
            Percent: 10.0,
            SameNum: 1,
            SubType: "None",
            SubstituteArrayId: -1,
            Type: "LockerSticker",
        },
    },
    {
        value: "LockerFigure",
        label: t("translation:CommonMsg.Glossary.Figure"),
        original: {
            Grade: 5,
            NotSameNum: 2,
            Percent: 10.0,
            SameNum: 1,
            SubType: "None",
            SubstituteArrayId: -1,
            Type: "LockerFigure",
        },
    },
    {
        value: "DrinkTicket",
        label: t("other:Extra.Drink"),
        original: {
            Grade: 5,
            NotSameNum: 1,
            Percent: 14.0,
            SameNum: 1,
            SubType: "None",
            SubstituteArrayId: -1,
            Type: "DrinkTicket",
        },
    },
    {
        value: "Food50",
        label: t("other:Extra.FoodTicket") + " (50%)",
        original: {
            Grade: 5,
            NotSameNum: 1,
            Percent: 13.0,
            SameNum: 1,
            SubType: "Food50",
            SubstituteArrayId: -1,
            Type: "FoodTicket",
        },
    },
]

export const get_ability_labels = t => {
    const res = []
    for (const ability of Object.keys(SkillIDs)) {
        if (ability !== "Unknown") {
            res.push({
                value: ability,
                label: t("translation:CommonMsg.Gear.GearPowerName." + ability),
            })
        }
    }
    return res
}

export const get_brand_labels = t => {
    const res = []
    for (const brand of brand_names) {
        res.push({
            value: brand,
            label: t("translation:CommonMsg.Gear.GearBrandName." + brand),
        })
    }
    return res
}

export const get_fresh_labels = (t, classes) => {
    const res = [
        {
            value: true,
            label: <FontAwesomeIcon icon={faHeartFilled} className={classes.likedColor} />,
        },
        {
            value: false,
            label: <FontAwesomeIcon icon={faHeart} className="fa-fw" />,
        },
    ]
    return res
}

export const get_murch_filter_labels = () => {
    let res = [
        {
            value: 0,
            label: (
                <div style={{ display: "flex" }}>
                    <div style={{ color: "red" }}>
                        <FontAwesomeIcon icon={faX} className="fa-fw" />
                    </div>
                    |
                    <div style={{ color: "gray" }}>
                        <FontAwesomeIcon icon={faCircle} className="fa-fw" />
                    </div>
                    <div style={{ color: "gray" }}>
                        <FontAwesomeIcon icon={faCircle} className="fa-fw" />
                    </div>
                    <div style={{ color: "gray" }}>
                        <FontAwesomeIcon icon={faCircle} className="fa-fw" />
                    </div>
                </div>
            ),
        },
        {
            value: 2,
            label: (
                <div style={{ display: "flex" }}>
                    <div style={{ color: "red" }}>
                        <FontAwesomeIcon icon={faX} className="fa-fw" />
                    </div>
                    |
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                    <div style={{ color: "gray" }}>
                        <FontAwesomeIcon icon={faCircle} className="fa-fw" />
                    </div>
                    <div style={{ color: "gray" }}>
                        <FontAwesomeIcon icon={faCircle} className="fa-fw" />
                    </div>
                </div>
            ),
        },
        {
            value: 4,
            label: (
                <div style={{ display: "flex" }}>
                    <div style={{ color: "red" }}>
                        <FontAwesomeIcon icon={faX} className="fa-fw" />
                    </div>
                    |
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                    <div style={{ color: "gray" }}>
                        <FontAwesomeIcon icon={faCircle} className="fa-fw" />
                    </div>
                </div>
            ),
        },
        {
            value: 6,
            label: (
                <div style={{ display: "flex" }}>
                    <div style={{ color: "red" }}>
                        <FontAwesomeIcon icon={faX} className="fa-fw" />
                    </div>
                    |
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                </div>
            ),
        },
        {
            value: 5,
            label: (
                <div style={{ display: "flex" }}>
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                    |
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                    <div style={{ color: "gray" }}>
                        <FontAwesomeIcon icon={faCircle} className="fa-fw" />
                    </div>
                </div>
            ),
        },
        {
            value: 7,
            label: (
                <div style={{ display: "flex" }}>
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                    |
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                    <div style={{ color: "green" }}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" />
                    </div>
                </div>
            ),
        },
    ]

    return res
}

export const get_seed_labels = t => {
    const res = [
        {
            value: true,
            label: <FontAwesomeIcon icon={faCheck} className="fa-fw" />,
        },
        {
            value: false,
            label: <FontAwesomeIcon icon={faX} className="fa-fw" />,
        },
    ]
    return res
}

export const getGearLabel = (t, gear, type) => {
    const langList =
        type === 0 ? "CommonMsg.Gear.GearName_Head" : type === 1 ? "CommonMsg.Gear.GearName_Clothes" : "CommonMsg.Gear.GearName_Shoes"
    return getName(t, langList, gear)
}

export const get_all_orderable_gear = t => {
    const entries = [
        ...gearHead
            .filter(e => e.HowToGet === "Shop" || e.HowToGet === "Catalog")
            .map(e => {
                return {
                    value: e,
                    type: 0,
                    label: getGearLabel(t, e, 0),
                }
            }),
        ...gearClothes
            .filter(e => e.HowToGet === "Shop" || e.HowToGet === "Catalog")
            .map(e => {
                return {
                    value: e,
                    type: 1,
                    label: getGearLabel(t, e, 1),
                }
            }),
        ...gearShoes
            .filter(e => e.HowToGet === "Shop" || e.HowToGet === "Catalog")
            .map(e => {
                return {
                    value: e,
                    type: 2,
                    label: getGearLabel(t, e, 2),
                }
            }),
    ]
    return entries
}

export const get_all_gear_ids_by_brand = brand => {
    const entries = {
        Head: gearHead.filter(e => e.Brand === brand),
        Clothes: gearClothes.filter(e => e.Brand === brand),
        Shoes: gearShoes.filter(e => e.Brand === brand),
    }
    return entries
}

export const mode_names = ["Pnt", "Var", "Vlf", "Vgl", "Vcl"]

export const mode_dict = Object.fromEntries(mode_names.map((item, idx) => [item, idx]))

export const default_single_style = () => {
    return {
        control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: "var(--border-color)",
            backgroundColor: "var(--title-bg-color)",
        }),
        singleValue: (styles, { data }) => ({
            ...styles,
            display: "flex",
            alignItems: "center",
            color: "var(--text-primary)",
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                borderColor: "var(--border-color)",
                backgroundColor: isDisabled
                    ? undefined
                    : isSelected
                    ? "var(--option-selected-bg-active)"
                    : isFocused
                    ? "var(--option-selected-bg)"
                    : undefined,
                color: isSelected ? "var(--text-primary)" : data.color,
                ":active": {
                    ...styles[":active"],
                    backgroundColor: !isDisabled ? (isSelected ? data.color : "var(--option-selected-bg)") : undefined,
                },
            }
        },
        menuList: (styles, { data }) => ({
            ...styles,
            borderColor: "var(--border-color)",
            backgroundColor: "var(--option-bg)",
        }),
        multiValue: (styles, { data }) => ({
            ...styles,
            borderColor: "var(--border-color)",
            backgroundColor: "var(--option-bg)",
        }),
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: "var(--primary-color)",
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: data.color,
            ":hover": {
                backgroundColor: data.color,
                color: "white",
            },
        }),
    }
}

export const default_multi_style = () => {
    return {
        control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: "var(--border-color)",
            backgroundColor: "var(--title-bg-color)",
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                borderColor: "var(--border-color)",
                backgroundColor: isDisabled
                    ? undefined
                    : isSelected
                    ? "var(--option-selected-bg-active)"
                    : isFocused
                    ? "var(--option-selected-bg)"
                    : undefined,
                color: isSelected ? "var(--text-primary)" : data.color,
                ":active": {
                    ...styles[":active"],
                    backgroundColor: !isDisabled ? (isSelected ? data.color : "var(--option-selected-bg)") : undefined,
                },
            }
        },
        menuList: (styles, { data }) => ({
            ...styles,
            borderColor: "var(--border-color)",
            backgroundColor: "var(--option-bg)",
        }),
        multiValue: (styles, { data }) => ({
            ...styles,
            borderColor: "var(--border-color)",
            backgroundColor: "var(--option-bg)",
        }),
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: "var(--primary-color)",
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: data.color,
            ":hover": {
                backgroundColor: data.color,
                color: "white",
            },
        }),
    }
}

export const seed_is_initalised = (userData, localKey) => {
    return (
        userData.CloudRandomSet !== undefined &&
        userData.CloudRandomSet.Map !== undefined &&
        userData.CloudRandomSet.Map[localKey] !== undefined &&
        !(
            userData.CloudRandomSet.Map[localKey].Context1 === 0 &&
            userData.CloudRandomSet.Map[localKey].Context2 === 0 &&
            userData.CloudRandomSet.Map[localKey].Context3 === 0 &&
            userData.CloudRandomSet.Map[localKey].Context4 === 0
        )
    )
}
